import script from "./RescueRequestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RescueRequestCard.vue?vue&type=script&setup=true&lang=js"

import "./RescueRequestCard.vue?vue&type=style&index=0&id=1a237deb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a237deb"]])

export default __exports__